// TimerDetailPage.js
import React, { useContext } from 'react';
import { Box, Typography, Paper, Grid, Button } from '@mui/material';
import TimerIcon from '@mui/icons-material/Timer';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useNavigate } from 'react-router-dom';
import  TimerContext  from '../../../contexts/Timer/TimerContext'; // Import the useTimer hook

function ProjectDetailPage() {
    const { currentTime, startTimeFormatted,selectedTask,description,startTime,endTime, } = useContext(TimerContext);

    const navigate = useNavigate();

    return (
        <Box sx={{ p: 3 }}>
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Project Details
                </Typography>
                <Grid container spacing={2} sx={{ml:0.1}}>
                    <Grid item xs={12}>
                        <Typography variant="h6">Phase:</Typography>
                        <Typography variant="body1">{selectedTask}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant="h6">Description:</Typography>
                        <Typography variant="body1">{description}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6">Start Time:</Typography>
                        <Typography variant="body1">{startTime}</Typography>
                    </Grid>
                    <Grid item  xs={12} sm={6}>
                        <Typography variant="h6">End Time:</Typography>
                        <Typography variant="body1">{endTime}</Typography>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6">Elapsed Time:</Typography>
                        <Box display="flex" alignItems="center">
                            <TimerIcon sx={{ mr: 1 }} />
                            <Typography variant="body1">{currentTime}</Typography>
                        </Box>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <Typography variant="h6">Start Time Formatted:</Typography>
                        <Box display="flex" alignItems="center">
                            <AccessTimeIcon sx={{ mr: 1 }} />
                            <Typography variant="body1">{startTimeFormatted}</Typography>
                        </Box>
                    </Grid>
                </Grid>
                <Box mt={4} ml={2}>
                    <Button variant="contained" color="primary"  onClick={() => navigate('/user/phases')}>
                        Back
                    </Button>
                </Box>
            </Paper>
        </Box>
    );
}

export default ProjectDetailPage;
